<template>
  <div class="riepilogo-ferie" v-loading="loading">
    <div class="row row-custom">
      <div class="riepilogo col-5">
        <div class="elemento row row-custom">
          <div class="titolo col-24 no-padding">
            {{ $t('ferie.titolo') }}
          </div>
        </div>
        <div v-if="country === '1'">
          <div class="elemento row row-custom">
            <div class="my-label col-16 no-padding">
              {{ $t('ferie.it_resTt') }}
            </div>
            <div class="my-value col-8 no-padding">
              {{ resTt }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="resGiugno">
            <div class="my-label col-16 no-padding">
              {{ $t('ferie.it_resGiugno') }}
            </div>
            <div class="my-value col-8 no-padding">
              {{ resGiugno }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="resDicembre">
            <div class="my-label col-16 no-padding">
              {{ $t('ferie.it_resDicembre') }}
            </div>
            <div class="my-value col-8 no-padding">
              {{ resDicembre }}
            </div>
          </div>
        </div>
        <div v-if="country === '2'">
          <div class="elemento row row-custom">
            <div class="my-label col-16 no-padding">
              {{ $t('ferie.fr_resCpNap') }}
            </div>
            <div class="my-value col-8 no-padding">
              {{ resCpNap }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="my-label col-16 no-padding">
              {{ $t('ferie.fr_resCpN') }}
            </div>
            <div class="my-value col-8 no-padding">
              {{ resCpN }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="my-label col-16 no-padding">
              {{ $t('ferie.fr_resRcr') }}
            </div>
            <div class="my-value col-8 no-padding">
              {{ resRcr }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="resRce !== ''">
            <div class="my-label col-16 no-padding">
              {{ $t('ferie.fr_resRce') }}
            </div>
            <div class="my-value col-8 no-padding">
              {{ resRce }}
            </div>
          </div>
        </div>
        <div v-if="country === '3'">
          <div class="elemento row row-custom">
            <div class="my-label col-16 no-padding">
              {{ $t('ferie.es_resVac') }}
            </div>
            <div class="my-value col-8 no-padding">
              {{ resVac }}
            </div>
          </div>
          <!--<div class="elemento row row-custom">
            <div class="my-label col-16 no-padding">
              {{ $t('ferie.es_resVacAA') }}
            </div>
            <div class="my-value col-8 no-padding">
              {{ resVacAA }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="my-label col-16 no-padding">
              {{ $t('ferie.es_resVacAC') }}
            </div>
            <div class="my-value col-8 no-padding">
              {{ resVacAC }}
            </div>
          </div>-->
          <div class="elemento row row-custom">
            <div class="my-label col-16 no-padding">
              {{ $t('ferie.es_resBH') }}
            </div>
            <div class="my-value col-8 no-padding">
              {{ resBH }}
            </div>
          </div>
        </div>
        <div v-if="country === '4'">
          <div class="elemento row row-custom">
            <div class="my-label col-16 no-padding">
              {{ $t('ferie.be_resCpl') }}
            </div>
            <div class="my-value col-8 no-padding">
              {{ resCpl }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="my-label col-16 no-padding">
              {{ $t('ferie.be_resCpe') }}
            </div>
            <div class="my-value col-8 no-padding">
              {{ resCpe }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="my-label col-16 no-padding">
              {{ $t('ferie.be_resRtt') }}
            </div>
            <div class="my-value col-8 no-padding">
              {{ resRtt }}
            </div>
          </div>
          <div class="elemento row row-custom" v-show="this.resRhsVisible">
            <div class="my-label col-16 no-padding">
              {{ $t('ferie.be_resRhs') }}
            </div>
            <div class="my-value col-8 no-padding">
              {{ resRhs }}
            </div>
          </div>
        </div>
        <div v-if="country === '5'">
          <div class="elemento row row-custom">
            <div class="my-label col-16 no-padding">
              {{ $t('ferie.de_resAp') }}
            </div>
            <div class="my-value col-8 no-padding">
              {{ formatDecimal(resAp, 'd') }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="my-label col-16 no-padding">
              {{ $t('ferie.de_resAc') }}
            </div>
            <div class="my-value col-8 no-padding">
              {{ formatDecimal(resAc, 'd') }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="my-label col-16 no-padding">
              {{ $t('ferie.de_resRh1') }}
            </div>
            <div class="my-value col-8 no-padding">
              {{ formatDecimal(resRh1, 'h') }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="my-label col-16 no-padding">
              {{ $t('ferie.de_resRh2') }}
            </div>
            <div class="my-value col-8 no-padding">
              {{ formatDecimal(resRh2, 'h') }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="my-label col-16 no-padding">
              {{ $t('ferie.de_resRh3') }}
            </div>
            <div class="my-value col-8 no-padding">
              {{ formatDecimal(resRh3, 'h') }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="my-label col-16 no-padding">
              {{ $t('ferie.de_resRh4') }}
            </div>
            <div class="my-value col-8 no-padding">
              {{ formatDecimal(resRh4, 'h') }}
            </div>
          </div>
        </div>
      </div>
      <div class="elenco col-19">
        <div class="box" :style="{ height: (tableHeight - 20) + 'px' }">
          <div class="col-24 no-padding action">
            <div class="row row-custom">
              <div class="col-12 filter">
                <icon name="riv-arrow" scale="1.6" flip="horizontal" @click.native="changeAnno(-1)" class="iconArrow">
                </icon>
                <span>{{ anno }}</span>
                <icon name="riv-arrow" scale="1.6" @click.native="changeAnno(1)" class="iconArrow"></icon>
              </div>
              <div class="nuova-richiesta col-12 no-padding">
                <el-button class="WEB-button WEB-button-primary" @click="goToNuovaRichiesta">
                  {{ $t('ferie.nuovaRichiesta').toUpperCase() }}
                </el-button>
              </div>
            </div>
          </div>
          <div class="col-24">
            <el-table :data="richieste" :empty-text="$t('ferie.noData')" width="100%" class="custom-table table-ferie"
              :height="100 % - 56 - 60 - 80" highlight-current-row>


              <el-table-column header-align="center" align="center" width="50">


                <template slot-scope="scope" slot="header">
                  <div class="icon-title">
                    <el-popover placement="top" v-model="visibleInfo" :key="scope.toString()">
                      <div>
                        <div>
                          <icon name="riv-circle" class="status-send" scale="0.8"></icon>
                          <span>{{ $t('ferie.status.A') }}</span>
                        </div>
                        <div>
                          <icon name="riv-circle" class="status-approved" scale="0.8"></icon>
                          <span>{{ $t('ferie.status.C') }}</span>
                        </div>
                        <div>
                          <icon name="riv-circle" class="status-rejected" scale="0.8"></icon>
                          <span>{{ $t('ferie.status.R') }}</span>
                        </div>
                      </div>

                      <span slot="reference">
                        <icon class="pointer" name="riv-help" scale="1"></icon>
                      </span>
                    </el-popover>

                  </div>
                </template>


                <template slot-scope="scope">
                  <div class="data-wrapper">
                    <el-tooltip class="item" effect="dark" :content="$t('ferie.status.' + scope.row.stato)"
                      placement="top-start">
                      <icon name="riv-circle" :class="getStatoClass(scope.row.stato)" scale="0.8"></icon>
                    </el-tooltip>
                  </div>
                </template>

              </el-table-column>

              <el-table-column prop="descTipoAssenza" header-align="center" :label="($t('ferie.tipo'))" min-width="200">
              </el-table-column>

              <el-table-column header-align="center" align="center" :label="($t('ferie.dt_creazione'))" width="120">

                <template slot-scope="scope">
                  <div class="name-wrapper">
                    {{ scope.row | getCreationDate }}
                  </div>
                </template>

              </el-table-column>

              <el-table-column header-align="center" align="center" :label="($t('ferie.periodo'))" width="160">

                <template slot-scope="scope">
                  <div class="name-wrapper">
                    {{ scope.row | getPeriodo }}
                  </div>
                </template>

              </el-table-column>

              <el-table-column header-align="center" align="center" :label="($t('ferie.orario'))" width="140">

                <template slot-scope="scope">
                  <div class="name-wrapper">
                    {{ scope.row | getOrario }}
                  </div>
                </template>

              </el-table-column>

              <!--<el-table-column header-align="center" align="center"
                :label="($t('ferie.dal'))"
                min-width="100">

                <template slot-scope="scope">
                  <div class="name-wrapper">
                    {{ scope.row.dataDal | formatDate }}
                  </div>
                </template>

              </el-table-column>
              <el-table-column header-align="center" align="center"
                :label="($t('ferie.al'))"
                width="100">

                <template slot-scope="scope">
                  <div class="name-wrapper">
                    {{ scope.row.dataAl | formatDate }}
                  </div>
                </template>

              </el-table-column>-->
              <el-table-column header-align="center" align="center" :label="($t('ferie.numOre'))" width="140">

                <template slot-scope="scope">
                  <div class="name-wrapper">
                    {{ (scope.row.oreAssenza !== '0,00') ? scope.row.oreAssenza : ' ' }}
                  </div>
                </template>

              </el-table-column>
              <!--<el-table-column header-align="center" align="center"
                :label="($t('ferie.oreDa'))"
                width="100">

                <template slot-scope="scope">
                  <div class="name-wrapper">
                    {{ (scope.row.oraIni !== '0,00') ? scope.row.oraIni : ' ' }}
                  </div>
                </template>

              </el-table-column>
              <el-table-column header-align="center" align="center"
                :label="($t('ferie.oreA'))"
                width="100">

                <template slot-scope="scope">
                  <div class="name-wrapper">
                    {{ (scope.row.oraFin !== '0,00') ? scope.row.oraFin : ' ' }}
                  </div>
                </template>

              </el-table-column>-->

              <el-table-column align="center" header-align="center" :label="($t('ferie.dip'))" width="100">

                <template slot-scope="scope">
                  <div class="actions" v-if="scope.row.notaDip !== ''">
                    <el-tooltip placement="left">
                      <div slot="content" v-html="scope.row.notaDip.split('\\n').join('\n')"
                        style="white-space: pre-line"></div>
                      <icon name="riv-addnotes" scale="1.2"></icon>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>

              <el-table-column align="center" header-align="center" :label="($t('ferie.resp'))" width="100">

                <template slot-scope="scope">
                  <div class="actions" v-if="scope.row.notaResp !== ''">
                    <el-tooltip placement="left">
                      <div slot="content" v-html="scope.row.notaResp.split('\\n').join('\n')"
                        style="white-space: pre-line"></div>
                      <icon name="riv-addnotes" scale="1.2"></icon>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>


              <el-table-column align="center" header-align="center" width="50">

                <template slot-scope="scope">
                  <div class="actions">
                    <icon v-if="(scope.row.seGest === 'S')" class="pointer" name="riv-delete2" scale="1.1"
                      @click.native="deleteRichiesta(scope.row)"></icon>
                  </div>
                </template>
              </el-table-column>


              <!--<el-table-column
                align="center" header-align="center"
                :label="($t('ferie.note'))"
                width="70">

                <template slot-scope="scope">
                  <div class="actions">
                    <icon class="pointer" name="riv-arrow" scale="1.1" @click.native="showNote(scope.row)"></icon>
                  </div>
                </template>

              </el-table-column>-->

            </el-table>

            <el-pagination :current-page="currentPage" v-if="(nrItems > pag_for)" background class="custom-pagination"
              layout="prev, pager, next" :total="nrItems" :page-size="pag_for" @current-change="changePage">
            </el-pagination>

          </div>

        </div>
      </div>
      <!--<div class="note col-4" :style="{ height: (tableHeight-20) + 'px'}">
        <div class="box" :style="{ height: (tableHeight-20) + 'px'}">
          <div class="note-dip">
            <div class="my-label">
              {{ $t('ferie.noteDip') }}
            </div>
            <div class="my-value">
              {{ notaDip }}
            </div>
          </div>
          <div class="note-resp">
            <div class="my-label">
              {{ $t('ferie.noteResp') }}
            </div>
            <div class="my-value">
              {{ notaResp }}
            </div>
          </div>
        </div>
      </div>-->
    </div>

    <!-- Dialog di creazione di una nuova richiesta di ferie -->
    <el-dialog :title="($t('ferie.titoloNuovaRichiesta').toUpperCase())" :visible.sync="showNuovaRichiesta"
      class="custom-dialog" :append-to-body="true" custom-class="offset-7 col-10">
      <el-form class="">
        <div class="elemento row row-custom">
          <div class="my-label col-6 no-padding">
            {{ $t('ferie.tipologia') }}
          </div>
          <div class="my-value col-18 no-padding">
            <el-select v-model="form.tipoAssenza" @change="changeTipoAssenza">
              <el-option v-for="item in tipiAssenza" :key="item.tipo" :label="item.descrizione" :value="item.tipo">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-6 no-padding">
            {{ $t('ferie.dataDa') }}
          </div>
          <div class="my-value col-18 no-padding">
            <el-date-picker class="dt-picker" v-model="form.periodo" type="daterange" @change="caclGGPesati"
              :range-separator="$t('placeholder.rangeSeparator')" :start-placeholder="$t('placeholder.startDate')"
              :end-placeholder="$t('placeholder.endDate')" format="dd/MM/yyyy" value-format="yyyyMMdd" :picker-options="{
                firstDayOfWeek: 1
              }">
            </el-date-picker>
          </div>
          <!--<div class="col-8 no-padding">
            <el-date-picker
              v-model="form.dataDal"
              type="date" format="dd/MM/yyyy" value-format="yyyyMMdd"
              placeholder="">
            </el-date-picker>
          </div>
          <div class="col-2 no-padding" style="text-align: center">
            {{ $t('ferie.dataA') }}
          </div>
          <div class="col-8 no-padding">
            <el-date-picker
              v-model="form.dataAl"
              type="date" format="dd/MM/yyyy" value-format="yyyyMMdd"
              placeholder="">
            </el-date-picker>
          </div>-->
        </div>
        <div class="elemento row row-custom" v-if="this.form.seGiorniPesati === 'S'">
          <div class="my-label col-6 no-padding">
            {{ $t('ferie.ggPesati') }}
          </div>
          <div class="my-value col-4 no-padding">
            <el-input type="text" placeholder="" v-model="form.ggPesati" :disabled="true">
            </el-input>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-6 no-padding">
            {{ $t('ferie.oraInizio') }}
          </div>
          <div class="my-value col-4 no-padding">
            <el-time-select @change="changeOre" v-model="form.oraIni" :disabled="oreDisabled" :picker-options="{
              start: '00:00',
              step: timeStep,
              end: '24:00'
            }" placeholder="">
            </el-time-select>
          </div>
          <div class="col-2 no-padding" style="text-align: center">
            {{ $t('ferie.to') }}
          </div>
          <div class="my-value col-4 no-padding">
            <el-time-select @change="changeOre" v-model="form.oraFin" :disabled="oreDisabled" :picker-options="{
              start: '00:00',
              step: timeStep,
              end: '24:00'
            }" placeholder="">
            </el-time-select>
          </div>
          <div class="col-4 no-padding" style="text-align: center">
            {{ this.country === '1' ? $t('ferie.numOre') : '' }}
          </div>
          <div class="my-value col-4 no-padding">
            <el-time-select v-if="this.country === '1'" v-model="form.oreAssenza" :disabled="oreDisabled"
              :picker-options="{
                start: '00:00',
                step: timeStep,
                end: '08:00'
              }" placeholder="">
            </el-time-select>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-6 no-padding">
            {{ $t('ferie.noteDip') }}
          </div>
          <div class="my-value col-18 no-padding">
            <el-input type="text" maxlength="60" placeholder="" v-model="form.notaDip">
            </el-input>
          </div>
        </div>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button class="WEB-button WEB-button-alternative" @click="showNuovaRichiesta = false">
          {{ $t('btn.annulla') }}
        </el-button>
        <el-button class="WEB-button WEB-button-primary" @click="confermaRichiesta">
          {{ $t('ferie.conferma').toUpperCase() }}
        </el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'RiepilogoFerie',
  props: ['tableHeight'],
  data() {
    return {
      loading: false,
      country: '',
      currentPage: 1,
      pag_for: 100,
      nrItems: 0,
      anno: 0,
      richieste: [],
      // Cotatori Italia
      resTt: '',
      resGiugno: "",
      resDicembre: "",
      // Contatori Francia
      resCpNap: '',
      resCpN: '',
      resRcr: '',
      resRce: '',
      // Contatori Spagna
      resVac: '',
      resVacAA: '',
      resVacAC: '',
      resBH: '',
      // Contatori Belgio
      resCpe: '',
      resCpl: '',
      resRtt: '',
      resRhs: '',
      resRhsVisible: false,
      // Contatori Germania
      resAc: '',
      resAp: '',
      resRh1: '',
      resRh2: '',
      resRh3: '',
      resRh4: '',
      //anni: [],
      showNuovaRichiesta: false,
      tipiAssenza: [],
      form: {
        tipoAssenza: '',
        dataDal: '',
        dataAl: '',
        oraIni: '',
        oraFin: '',
        notaDip: '',
        periodo: [],
        oreAssenza: '',
        minutiAssenza: '',
        seGiorniPesati: 'N',
        ggPesati: ''
      },
      oreDisabled: true,
      visibleInfo: false,
      notaDip: '',
      notaResp: '',
      timeStep: ''
    }
  },
  activated: function () {
    this.country = this.$store.state.country
    this.timeStep = this.country === '1' ? '00:30' : '00:05'
    let anno = new Date().getFullYear()
    this.$set(this, 'anno', anno)
    //this.anni = [anno - 1, anno, anno + 1]
    this.getRiepilogoFerie()
  },
  deactivated: function () {
    this.country = ""
    this.loading = false
    this.currentPage = 1
    this.nrItems = 0
    this.anno = 0
    this.$set(this, 'richieste', [])
    // Contatori Italia
    this.resTt = ''
    this.resGiugno = ''
    this.resDicembre = ''
    // Contatori Francia
    this.resCpNap = ''
    this.resCpN = ''
    this.resRcr = ''
    this.resRce = ''
    // Contatori Spagna
    this.resVac = ''
    this.resVacAA = ''
    this.resVacAC = ''
    this.resBH = ''
    // Contatori Belgio
    this.resCpe = ''
    this.resCpl = ''
    this.resRtt = ''
    this.resRhs = ''
    this.resRhsVisible = false
    // Contenitori Germania
    this.resAc = ''
    this.resAp = ''
    this.resRh1 = ''
    this.resRh2 = ''
    this.resRh3 = ''
    this.resRh4 = ''

    this.showNuovaRichiesta = false
    this.$set(this, 'tipiAssenza', [])
    let obj = {
      tipoAssenza: '',
      dataDal: '',
      dataAl: '',
      oraIni: '',
      oraFin: '',
      notaDip: '',
      periodo: [],
      oreAssenza: '',
      minutiAssenza: '',
      seGiorniPesati: 'N',
      ggPesati: ''
    }
    this.$set(this, 'form', obj)
    this.oreDisabled = true
    this.visibleInfo = false
    this.notaDip = ''
    this.notaResp = ''
    this.timeStep = ''
  },
  filters: {
    formatDate: function (date) {
      if (date !== '') {
        return date.substr(6, 2) + '/' + date.substr(4, 2) + '/' + date.substr(0, 4)
      } else {
        return '-'
      }
    },
    getPeriodo: function (row) {
      if (row.dataDal === row.dataAl) {
        return row.dataDal.substr(6, 2) + '/' + row.dataDal.substr(4, 2) + '/' + row.dataDal.substr(0, 4)
      } else {
        return row.dataDal.substr(6, 2) + '/' + row.dataDal.substr(4, 2) + '/' + row.dataDal.substr(0, 4) + ' - ' +
          row.dataAl.substr(6, 2) + '/' + row.dataAl.substr(4, 2) + '/' + row.dataAl.substr(0, 4)
      }
    },
    getOrario: function (row) {
      if (row.oraIni === '0,00' && row.oraFin === '0,00') {
        return ''
      } else if (row.oraIni !== '' && row.oraFin !== '') {
        return (row.oraIni.length === 4 ? '0' + row.oraIni : row.oraIni) + ' - ' + (row.oraFin.length === 4 ? '0' + row.oraFin : row.oraFin)
      } else {
        return ''
      }
    },
    getCreationDate: function (row) {
      if (row.id === undefined || row.id === '' || row.id.length < 10) {
        return ''
      } else {
        return moment(row.id.substr(0, 10), "YYYY-MM-DD").format("DD/MM/YYYY")
      }
    }
  },
  methods: {
    inviaRichiesta: function (rinunciaFraz) {
      let obj = JSON.parse(JSON.stringify(this.form))
      if (this.form.periodo === undefined || this.form.periodo.length !== 2) {
        this.$message({
          showClose: true,
          message: this.$i18n.t('ferie.errorNoPeriodo'),
          type: 'error',
          duration: process.env.duration
        })
      } else {
        obj.rinunciaFraz = rinunciaFraz
        obj.operazione = '*ADD'
        obj.oraIni = obj.oraIni === '' ? '00.00.00' : obj.oraIni.substr(0, 2) + '.' + obj.oraIni.substr(3, 2) + '.00'
        obj.oraFin = obj.oraFin === '' ? '00.00.00' : obj.oraFin.substr(0, 2) + '.' + obj.oraFin.substr(3, 2) + '.00'
        obj.dataDal = this.form.periodo[0]
        obj.dataAl = this.form.periodo[1]
        if (this.country === '1') {
          obj.oreAssenza = obj.oreAssenza === '' ? '00.00.00' : obj.oreAssenza.substr(0, 2) + '.' + obj.oreAssenza.substr(3, 2) + '.00'
        } else {
          obj.oreAssenza = ''
        }
        delete obj['periodo']
        this.$http.post('ferie/' + this.country + '/richiesta', obj, {
          params: {
            codLang: sessionStorage.getItem('codLang')
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.showNuovaRichiesta = false
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'success',
                duration: process.env.duration
              })
              this.getRiepilogoFerie()
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      }
    },
    confermaRichiesta: function () {
      let seFraz = ""
      for (let i = 0; i < this.tipiAssenza.length; i++) {
        if (this.tipiAssenza[i].tipo === this.form.tipoAssenza) {
          seFraz = this.tipiAssenza[i].seFraz === undefined ? 'S' : this.tipiAssenza[i].seFraz
        }
      }
      if (seFraz === 'S') {
        this.$confirm(this.$i18n.t('ferie.ifInviaRichiesta'), this.$i18n.t('ferie.attenzione'), {
          confirmButtonText: this.$i18n.t('ferie.si'),
          cancelButtonText: this.$i18n.t('ferie.no'),
          type: 'warning',
          showClose: false,
          closeOnClickModal: false
        }).then(() => {
          this.inviaRichiesta('1')
        }).catch(() => {
          this.inviaRichiesta('0')
        })
      } else {
        this.inviaRichiesta('0')
      }
    },
    changeTipoAssenza: function (tipoAssenza) {
      this.tipiAssenza.forEach((item) => {
        if (item.tipo === tipoAssenza) {
          this.oreDisabled = (item.seOre !== 'S')
          if (this.oreDisabled === true) {
            this.$set(this.form, 'oraIni', '')
            this.$set(this.form, 'oraFin', '')
            this.$set(this.form, 'oreAssenza', '')
          }
          this.$set(this.form, 'seGiorniPesati', item.seGiorniPesati)
          this.caclGGPesati()
        }
      })
    },
    goToNuovaRichiesta: function () {
      this.getTipiAssenza()
    },
    elimina: function (richiesta) {
      this.$http.delete('ferie/' + this.country + '/richiesta', {
        params: {
          id: richiesta.id,
          codLang: sessionStorage.getItem('codLang')
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.$set(this, 'currentPage', 1)
            this.getRiepilogoFerie()
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    deleteRichiesta: function (richiesta) {
      this.$confirm(this.$i18n.t('ferie.ifDelete'), this.$i18n.t('ferie.attenzione'), {
        confirmButtonText: this.$i18n.t('btn.elimina'),
        cancelButtonText: this.$i18n.t('btn.annulla'),
        type: 'warning'
      }).then(() => {
        this.elimina(richiesta)
      }).catch(() => {
        // Eventuale handler di annullamento cancellazione
      })
    },
    showNote: function (row, event, column) {
      this.notaDip = row.notaDip
      this.notaResp = row.notaResp
    },
    changeAnno: function (op) {
      this.anno = this.anno + op
      this.getRiepilogoFerie()
    },
    changePage: function (page) {
      this.$set(this, 'currentPage', page)
      this.getRiepilogoFerie()
    },
    getRiepilogoFerie: function () {
      this.loading = true
      this.$http.get('ferie/' + this.country + '/ferie', {
        params: {
          codLang: sessionStorage.getItem('codLang'),
          pag_action: (this.currentPage === 1) ? 'BEGIN' : 'NEXT',
          pag_for: this.pag_for,
          pag_from: this.currentPage,
          anno: this.anno
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            if (response.body.hasOwnProperty('data')) {
              this.$set(this, 'richieste', response.body.data)
            } else {
              this.$set(this, 'richieste', [])
            }
            if (this.currentPage === 1) {
              if (this.country === '1') {
                this.$set(this, 'resTt', response.body.attrib.resTt)
                this.$set(this, 'resGiugno', response.body.attrib.resGiugno)
                this.$set(this, 'resDicembre', response.body.attrib.resDicembre)
              } else if (this.country === '2') {
                this.$set(this, 'resCpNap', response.body.attrib.resCpNap)
                this.$set(this, 'resCpN', response.body.attrib.resCpN)
                this.$set(this, 'resRcr', response.body.attrib.resRcr)
                this.$set(this, 'resRce', response.body.attrib.resRce)
              } else if (this.country === '3') {
                this.$set(this, 'resVacAA', response.body.attrib.resVacAA)
                this.$set(this, 'resVacAC', response.body.attrib.resVacAC)
                this.$set(this, 'resVac', response.body.attrib.resVac)
                this.$set(this, 'resBH', response.body.attrib.resBH)
              } else if (this.country === '4') {
                this.$set(this, 'resCpl', response.body.attrib.resCpl)
                this.$set(this, 'resCpe', response.body.attrib.resCpe)
                this.$set(this, 'resRtt', response.body.attrib.resRtt)
                this.$set(this, 'resRhs', response.body.attrib.resRhs)
                let resRhsVisible = response.body.attrib.resRhsVisible === undefined || response.body.attrib.resRhsVisible === null || response.body.attrib.resRhsVisible === '0' ? false : true
                this.$set(this, 'resRhsVisible', resRhsVisible)
              } else if (this.country === '5') {
                this.$set(this, 'resAc', response.body.attrib.resAc)
                this.$set(this, 'resAp', response.body.attrib.resAp)
                this.$set(this, 'resRh1', response.body.attrib.resRh1)
                this.$set(this, 'resRh2', response.body.attrib.resRh2)
                this.$set(this, 'resRh3', response.body.attrib.resRh3)
                this.$set(this, 'resRh4', response.body.attrib.resRh4)
              } else if (this.country === '6') {

              }

              this.$set(this, 'nrItems', (response.body.attrib.size !== '') ? parseInt(response.body.attrib.size) : 0)
            }
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    getTipiAssenza: function () {
      this.$http.get('ferie/' + this.country + '/tipiassenza', {
        params: {
          codLang: sessionStorage.getItem('codLang')
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'tipiAssenza', response.body.data)
            this.$set(this, 'form', {})
            this.$set(this.form, 'oraIni', '')
            this.$set(this.form, 'oraFin', '')
            this.$set(this.form, 'oreAssenza', '')
            this.$set(this.form, 'tipoAssenza', '')
            //this.$set(this.form, 'tipoAssenza', response.body.data[0].tipo)
            this.$set(this, 'showNuovaRichiesta', true)
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    getStatoClass: function (stato) {
      switch (stato) {
        case 'A':
          return 'status-send'
        case 'C':
          return 'status-approved'
        case 'R':
          return 'status-rejected'
        default:
          return ''
      }
    },
    changeOre: function () {
      if (this.form.oraIni !== '' && this.form.oraFin !== '') {
        var startTime = moment(this.form.oraIni, 'HH:mm');
        var endTime = moment(this.form.oraFin, 'HH:mm');

        // calculate total duration
        var duration = moment.duration(endTime.diff(startTime));

        // duration in hours
        var hours = parseInt(duration.asHours());
        if (hours >= 8) {
          this.$set(this.form, 'oreAssenza', '08:00')
        } else {
          hours = '0' + hours
          var minutes = parseInt(duration.asMinutes()) % 60;
          if (minutes < 10) {
            minutes = '0' + minutes
          }
          this.$set(this.form, 'oreAssenza', hours + ':' + minutes)
        }
        /*if (hours < 10) {
          hours = '0' + hours
        }
        var minutes = parseInt(duration.asMinutes()) % 60;
        if (minutes < 10) {
          minutes = '0' + minutes
        }
        // duration in minutes
        console.log(hours + ':' + minutes)
        this.$set(this.form, 'oreAssenza', hours + ':' + minutes)*/
      }
    },
    formatDecimal: function (value, label) {
      if (value !== '') {
        return value + ' (' + this.$i18n.t('ferie.' + label) + ')'
      } else {
        return '0,00' + ' (' + this.$i18n.t('ferie.' + label) + ')'
      }
    },
    caclGGPesati: function () {
      if (this.form.periodo && this.form.seGiorniPesati === 'S') {

        this.$http.get("ferie/" + this.country + '/giornipesati', {
          params: {
            codLang: sessionStorage.getItem('codLang'),
            tipoAssenza: this.form.tipoAssenza,
            dataDal: this.form.periodo[0],
            dataAl: this.form.periodo[1]
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this.form, 'ggPesati', response.body.data.nrGiorni)
            } else {
              this.$set(this.form, 'ggPesati', '')
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      } else {
        this.$set(this.form, 'ggPesati', '')
      }
    }
  }
}
</script>


<style lang="less">
@import "../../assets/less/general.less";

/*
    .modal-nuova-richista {
      .el-dialog__body {
        .elemento {
          margin-bottom: 10px;
          .el-select {
            width: 100%;
            .el-input__inner {
              height: 22px;
              line-height: 22px;
              border: 0px;
              border-bottom: 1px solid #e7e7e7;
              border-radius: 0px;
              padding-left: 0px;
              padding-right: 10px;
            }
            .el-input__suffix {
              right: -5px;
            }
          }
          .el-date-editor {
            width: 100%;
            .el-input__inner {
              height: 22px;
              line-height: 22px;
              border-radius: 0px;
            }
            .el-input__inner:focus {
              border-color: @greenRiva;
            }
            .el-input__icon {
              line-height: 22px;
            }
          }
          .el-textarea {
            .el-textarea__inner {
              border-radius: 0px;
              padding-left: 5px;
              line-height: 22px;
            }
            .el-textarea__inner:focus {
              border-color: @greenRiva;
            }
          }
        }
      }
      .el-dialog__footer {
        padding: 10px 0px 20px 0px;
        .el-button {
          border: 1px solid @oroRiva;
          color: @oroRiva;
          border-radius: 0px;
          font-size: 12px;
          text-transform: uppercase;
          letter-spacing: 2px;
          -moz-box-shadow: 3px 3px 4px #cccccc;
          -webkit-box-shadow: 3px 3px 4px #cccccc;
          box-shadow: 3px 3px 4px #cccccc;
        }
        .el-button:hover {
          background-color: @white;
        }
        .el-button--primary {
          background-color: @oroRiva;
          border-color: @oroRiva;
          color: @white;
          font-size: 12px;
          letter-spacing: 2px;
        }
        .el-button--primary:hover {
          background-color: @oroRiva;
        }
      }
    }
    */

.riepilogo-ferie {
  height: 100%;
  padding: 0;

  .riepilogo {
    height: 100%;
    padding-right: 15px;
    padding-left: 15px;

    .elemento {
      line-height: 40px;

      .titolo {
        height: 60px;
        line-height: 30px;
        text-align: left;
        padding-top: 15px;
        padding-bottom: 15px;
        letter-spacing: 3px;
        text-transform: uppercase;
        .set-font(@size: 16px, @color: @oroRiva, @weight: bold, @family: 'os-regular');
      }

      .my-label {
        text-align: left;
        .set-font(@size: 14px, @color: @greenRiva, @weight: bold, @family: 'os-regular');
      }

      .my-value {
        text-align: right;
        .set-font(@size: 14px, @color: @textTable, @family: 'os-regular');
      }
    }
  }

  .elenco {
    height: calc(100vh - 56px - 66px);
    padding: 10px;

    .box {
      overflow: auto;
      background-color: #f2f2f2;
      border-radius: 5px;

      .action {
        height: 80px;

        .filter {
          margin-top: 10px;
          text-align: left;
          line-height: 40px;

          .iconArrow {
            cursor: pointer;
            display: inline-block;
            position: relative;
            top: -2px;
            .set-font(@color: @oroRiva, @weight: bold, @family: 'os-regular');
          }

          span {
            .set-font(@size: 16px, @color: @greenRiva, @weight: bold, @family: 'os-regular');
          }
        }

        .nuova-richiesta {
          text-align: right;

          .el-button {
            margin-top: 10px;
            margin-right: 10px;
          }
        }
      }

      .el-table {
        background-color: #f2f2f2;

        .el-table__header {
          thead {
            tr {
              background-color: #f2f2f2;
            }

            th {
              background-color: #f2f2f2;
            }
          }
        }
      }

      .el-table__body {
        .el-table__row {
          background-color: #f2f2f2;
        }

      }
    }

    .table-ferie {
      height: calc(100vh - 56px - 60px - 153px);
    }
  }

  .note {
    padding: 10px 10px 10px 0px;

    .box {
      border: 1px solid #f2f2f2;

      .note-dip,
      .note-resp {
        .my-label {
          text-align: left;
          margin: 10px;
          border-bottom: 2px solid @greenRiva;

          padding-bottom: 5px;
          .set-font(@size: 16px, @color: @greenRiva, @weight: bold, @family: 'os-regular');
        }

        .my-value {
          text-align: left;
          margin: 10px;
          .set-font(@size: 14px, @color: @textTable, @family: 'os-regular');
        }

        height: 150px;
      }
    }

  }

}

.status-saved {
  color: @grayMedium;
}

.status-send {
  color: @orangeMedium;
}

.status-approved {
  color: @greenApproved
}

.status-rejected,
.status-delete {
  color: #f44336
}

.el-input-number {
  line-height: 22px;
  border-bottom: 1px solid #DCDFE6;

  .el-input-number__decrease {
    height: 22px;
    border-bottom: 1px solid #DCDFE6;
    left: 0;
  }

  .el-input-number__increase {
    height: 22px;
    border-bottom: 1px solid #DCDFE6;
    right: 0;
  }

  .el-input {
    input {
      border: none !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Ferie/RiepilogoFerie.vue